export default __webpack_public_path__ + "static/146210503-24811800-bb26-4244-817d-6422b20e6786-cdd344ef3efada942fa3ba4747bf4dca.png";